"use strict";

exports.__esModule = true;
exports.getKeywordTermsCount = getKeywordTermsCount;
var _keywordExtractor = _interopRequireDefault(require("keyword-extractor"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function getKeywordTermsCount(data) {
  var asString = data.join(" ").replace(/\s+/, " ").replace(/----.*/, "");
  var keywords = _keywordExtractor["default"].extract(asString, {
    language: "english",
    remove_digits: true,
    return_changed_case: true,
    remove_duplicates: false
  });
  var keywordsWithCount = keywords.reduce(function (output, word) {
    output[word] = output[word] ? output[word] + 1 : 1;
    return output;
  }, {});
  return Object.keys(keywordsWithCount).map(function (word) {
    return [word, keywordsWithCount[word]];
  })
  // eslint-disable-next-line no-nested-ternary
  .sort(function (a, b) {
    return a[0] < b[0] ? -1 : a[0] > b[0] ? 1 : 0;
  }) // by word
  .sort(function (a, b) {
    return a[1] - b[1];
  });
  // by count
}